<template>
    <nav v-if="breadcrumbs" aria-label="breadcrumb">
        <ol class="list">
            <li v-for="crumb in breadcrumbs" :key="crumb.step">
                <a :href="crumb.route.path" @click.prevent="navigate(crumb)">{{
                    crumb.title
                }}</a>
            </li>
        </ol>
    </nav>
</template>

<script>
import { mapGetters } from "vuex";

import {
    FLOW_TYPE_ZONE_TICKET,
    FLOW_TYPE_FIXED_PRICE_TICKET,
    FLOW_TYPE_RETIREE_TICKET,
    FLOW_STEP_CUSTOMER_INFORMATION,
    FLOW_STEP_CONFIRM_BASKET,
    FLOW_STEP_ORDER_CONFIRMED,
    FLOW_TYPE_CONTROLFEE
} from "@/store/modules/flow";

export default {
    computed: {
        ...mapGetters({
            flowType: "flow/getType",
            flowCurrentStep: "flow/getStep",
            flowPreviousSteps: "flow/getPrevious"
        }),
        texts() {
            return {
                [FLOW_TYPE_ZONE_TICKET]: this.$t("page_new_zone_ticket.title"),
                [FLOW_TYPE_RETIREE_TICKET]: this.$t(
                    "page_new_retiree_ticket.title"
                ),
                [FLOW_TYPE_FIXED_PRICE_TICKET]: this.$t(
                    "page_new_fixed_price_ticket.title"
                ),
                [FLOW_TYPE_CONTROLFEE]: this.$t(
                    "page_controlfee.title"
                ),
                [FLOW_STEP_CUSTOMER_INFORMATION]: this.$t(
                    "page_customer_information.title"
                ),
                [FLOW_STEP_CONFIRM_BASKET]: this.$t(
                    "page_confirm_basket.title"
                ),
                [FLOW_STEP_ORDER_CONFIRMED]: this.$t(
                    "page_order_confirmed.title"
                )
            };
        },
        breadcrumbs() {
            if (!this.flowType) return null;

            const crumbs = [];

            crumbs.push({
                title: this.texts[this.flowType],
                route: this.$router.flowToRoute(this.flowType)
            });

            if (this.flowCurrentStep) {
                const steps = [...this.flowPreviousSteps, this.flowCurrentStep];

                steps.forEach(step => {
                    const title = this.texts[step];

                    if (title) {
                        crumbs.push({
                            step,
                            title,
                            route: this.$router.flowToRoute(this.flowType, step)
                        });
                    }
                });
            }

            return crumbs.filter(c => c.route);
        }
    },
    methods: {
        navigate(crumb) {
            if (crumb.step) {
                this.$store.commit("flow/goBack", crumb.step);
            } else if (crumb.route) {
                this.$router.push(crumb.route);
            }
        }
    }
};
</script>

<style scoped lang="scss">
.list {
    display: flex;
    margin: 0.5rem 0;
    padding: 0;
    list-style: none;
    font-size: 0.8rem;
}

.list a {
    text-decoration: none;
    color: $color-dark-grey;
    font-size: inherit;
}

.list li + li {
    margin-left: 0.4rem;
}

.list li + li::before {
    content: "→";
    content: "→" / "";
    padding-right: 0.4rem;
}

.list li:last-child a {
    color: $color-primary;
}
</style>
